<template>
  <div style="z-index:10000">
    <b-button 
      style="
        position: fixed;
        right: 0px;
        top: 50%;
        transform: translateY(-50%);
      " 
      v-b-toggle.sidebar-right
    ><CIcon name="cil-settings"/></b-button>
    <b-sidebar id="sidebar-right" :width="'280px'" title="" right backdrop shadow>
      <div class="m-2 mx-3">
        <CCol>
          <CRow row="12" v-if="$store.state.role_aktif.kodeRole === 'super'">
          <!-- <CRow row="12"> -->
            <b-form-group
              class="w-100"
              label="Mitra"
              label-for="mitra"
            >
              <Multiselect
                class="w-100"
                v-model="data.mitra"
                :options="listMitra"
                :multiple="false"
                :searchable="true"
                :close-on-select="true"
                :show-labels="false"
                label="namaMitra"
                track-by="id"
                placeholder="-- pilih mitra --"
                @input="pilihMitra(), getKoordinator(data.mitra)"
              ></Multiselect>
            </b-form-group>
          </CRow>
          <CRow row="12">
            <b-form-group
              class="w-100"
              label="Koordinator"
              label-for="koordinator"
            >
              <Multiselect
                class="w-100"
                v-model="data.koordinator"
                :options="listKoordinator"
                :multiple="false"
                :searchable="true"
                :close-on-select="true"
                :show-labels="false"
                label="namaKoordinator"
                track-by="id"
                placeholder="-- pilih koordinator --"
                @input="pilihKoordinator(), getCabang(data.koordinator)"
              ></Multiselect>
            </b-form-group>
          </CRow>
          <CRow row="12">
            <b-form-group
              class="w-100"
              label="Cabang"
              label-for="cabang"
            >
              <Multiselect
                class="w-100"
                v-model="data.cabang"
                :options="listCabang"
                :multiple="false"
                :searchable="true"
                :close-on-select="true"
                :show-labels="false"
                label="namaCabang"
                track-by="id"
                placeholder="-- pilih cabang --"
                @input="pilihCabang(), getCapem(data.cabang)"
              ></Multiselect>
            </b-form-group>
          </CRow>
          <CRow row="12">
            <b-form-group
              class="w-100"
              label="Capem"
              label-for="capem"
            >
              <Multiselect
                class="w-100"
                v-model="data.capem"
                :options="listCapem"
                :multiple="false"
                :searchable="true"
                :close-on-select="true"
                :show-labels="false"
                label="namaCapem"
                track-by="id"
                placeholder="-- pilih capem --"
                @input="pilihCapem()"
              ></Multiselect>
            </b-form-group>
          </CRow>
        </CCol>
      </div>
    </b-sidebar>
  </div>
</template>

<script>
export default {
  name: "sidebarRight",
  data() {
    return {
      data: {
        mitra: null,
        koordinator: null,
        cabang: null,
        capem: null,
      },
      listMitra: [],
      listKoordinator: [],
      listCabang: [],
      listCapem: [],
    }
  },
  computed: {
    mitra_aktif(){
      return this.$store.state.mitra_aktif
    },
    koordinator_aktif(){
      return this.$store.state.koordinator_aktif
    },
    cabang_aktif(){
      return this.$store.state.cabang_aktif
    },
    capem_aktif(){
      return this.$store.state.capem_aktif
    },
  },
  watch: {
    mitra_aktif(newVar, oldVar){
      if(newVar != oldVar){
        this.data.mitra = newVar
        this.getKoordinator(newVar)
        // this.$router.push({ path: "/dashboard" });
      }
    },
    koordinator_aktif(newVar, oldVar){
      if(newVar != oldVar){
        this.data.koordinator = newVar
        this.getCabang(newVar)
      }
    },
    cabang_aktif(newVar, oldVar){
      if(newVar != oldVar){
        this.data.cabang = newVar
        this.getCapem(newVar)
      }
    },
    capem_aktif(newVar, oldVar){
      if(newVar != oldVar){
        this.data.capem = newVar
      }
    }
  },
  mounted() {
    const vm = this
    // console.log(vm.$store.state)
    vm.data.mitra = vm.$store.state.mitra_aktif
    vm.data.koordinator = vm.$store.state.koordinator_aktif
    vm.data.cabang = vm.$store.state.cabang_aktif
    vm.data.capem = vm.$store.state.capem_aktif

    vm.getDatas()
    vm.getKoordinator(vm.data.mitra)
    vm.getCabang(vm.data.koordinator)
    vm.getCapem(vm.data.cabang)
  },
  methods: {
    async getDatas(){
      const vm = this
      let listMitra = await vm.$axios('/mitra/list')
      vm.listMitra = listMitra.data.status == 200 ? listMitra.data.data : []
    },
    async getKoordinator(x){
      const vm = this
      if(x){
        let listKoordinator = await vm.$axios('koordinator/listKoordinatorByMitraId/' + x.id)
        vm.listKoordinator = listKoordinator.data.status == 200 ? listKoordinator.data.data : []
      }
    },
    async getCabang(x){
      const vm = this
      if(x){
        let listCabang = await vm.$axios('cabang/listCabangByKoordinatorId/' + x.id)
        vm.listCabang = listCabang.data.status == 200 ? listCabang.data.data : []
      }
    },
    async getCapem(x){
      const vm = this
      if(x){
        let listCapem = await vm.$axios('capem/listCapemByCabangId/' + x.id)
        vm.listCapem = listCapem.data.status == 200 ? listCapem.data.data : []
      }
    },
    async pilihMitra(){
      const vm = this
      vm.$store.commit("set_mitra", vm.data.mitra);
      vm.$store.commit("set_koordinator", null)
      vm.$store.commit("set_cabang", null)
      vm.$store.commit("set_capem", null)
      vm.listKoordinator = []
      vm.listCabang = []
      vm.listCapem = []
      await vm.$router.push({ path: "/login" })
      await vm.$router.push({ path: "/dashboard" })
    },
    pilihKoordinator(){
      const vm = this
      vm.$store.commit("set_koordinator", vm.data.koordinator);
      vm.$store.commit("set_cabang", null)
      vm.$store.commit("set_capem", null)
      vm.listCabang = []
      vm.listCapem = []
    },
    pilihCabang(){
      const vm = this
      vm.$store.commit("set_cabang", vm.data.cabang);
      vm.$store.commit("set_capem", null)
      vm.listCapem = []
    },
    pilihCapem(){
      const vm = this
      vm.$store.commit("set_capem", vm.data.capem);
    },
  },
};
</script>
